module.exports = __webpack_public_path__ + "static/elderberry-c50a9634030c1147d1ccaa8ffa6a281e.svg";